export default __webpack_public_path__ + "media/images/footer-instagram-social-dbb7a13c3c3ed01e0e9bf5ac10d2240a.svg";